import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '..';
import { adminGetUserById } from './AdminUsersApi';

export interface IUserRole {
  _id: string;
  name: 'Admin' | 'Approver' | 'Enterer' | 'Student' | 'Tutor' | 'Guest';
  type: 'admin' | 'user';
  createdAt: string;
  permissions: IUserPermissions;
  updatedAt?: string;
}
export interface IBaseUser {
  _id: string;
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  avatar?: string;
  createdAt: string;
  updatedAt?: string;
  role: IUserRole;
  lastLogin?: string;
}

export interface IUserPermissions {
  quiz?: Array<'view'>;
  submission?: Array<'view' | 'create' | 'edit' | 'delete'>;
  quizHistory?: Array<'view'>;
  // ADMIN
  adminSubTopic?: Array<'view' | 'create' | 'edit' | 'delete'>;
  adminQuestion?: Array<'view' | 'create' | 'edit' | 'delete' | 'approve'>;
  adminQuiz?: Array<'view' | 'create' | 'edit' | 'delete' | 'publish'>;
  adminStudent?: Array<'view'>;
}

export interface IUserCurriculum {
  curriculum: string;
  grade: string;
  subject: string;
  subjectCode: string;
}

export interface IUser extends IBaseUser {
  isQuiztopiyaPendingTrial?: boolean;
  assessmentEngineDate?: string;
  quiztopiyaTrialExpiration?: string;
  curriculums?: Array<IUserCurriculum>;
  isContinueSubmissionWithTimerEnabled?: boolean;
  isLeadGenSubmitted?: boolean;
  students?: Array<{
    username: string;
  }>;
  tutopiyaUserId?: string;
}

export interface IUsersState {
  status: 'idle' | 'loading' | 'rejected';
  count: number;
  user: IUser | undefined;
}

const initialState: IUsersState = {
  status: 'idle',
  count: 0,
  user: undefined,
};

export const UsersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET USER BY ID
      .addCase(adminGetUserById.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(adminGetUserById.fulfilled, (state, action) => {
        state.status = 'idle';
        state.user = action.payload;
      })
      .addCase(adminGetUserById.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const getUsersState = (state: RootState): RootState['users'] =>
  state.users;

export * from './AdminUsersApi';
export default UsersSlice.reducer;
